export default {
    title: 'My Cart',
    chooseDeliveryLocation: 'Choose delivery location',
    backButton: 'Back to the store',
    proceedError: 'Please check that the quantities of products are good and that you have met the minimum delivery price requirement for each of the stores.',
    sideCard: {
        title: "Order overview",
        sum: "Sum",
        delivery: "Delivery",
        surcharge: "Surcharge",
        total: "Total",
        proceedButton: "Pay"
    },
    storeCard: {
        items: {
            only: 'Only',
            leftInStorage: 'left in storage',
            zero: 'The quantity must be at least',
            outOfStock: 'Out of stock'
        },
        priceColumn: {
            surcharge: "Surcharge",
            cashOnDelivery: "Cash on delivery",
            delivery: "Delivery",
            deliveryDate: 'Estimated delivery date',
        },
        removedItem: {
            text: "was removed from the cart",
            button: "Cancel"
        },
        footer: {
            message: {
                dependCityPrice: "Delivery and surcharge prices depend on the city in which the order is delivered.",
                warning: {
                    deliverToAddress: "The store does not deliver to the selected address.",
                    orderValue: {
                        minumum: "The store does not deliver goods with a total value of less than",
                        current: "Current value"
                    }
                }
            }
        }
    },
    bannerPayment: {
        methods: "Payment methods",
        safeShopping: {
            text: "Safe shopping",
            description: "Safe refund if the product is not delivered or does not match the description."
        },
        cashOnDelivery: "Cash on delivery"
    },
    reccomendedProducts: "Recommended products",
    successDeleteMessage: "Product has been successfully removed from your cart.",
    successWishListMessage: "Product has been successfully removed from your cart and added to your wish list.",
    modal: {
        title: "My cart",
        total: "Total",
        seeCart: "See cart",
        detailsInfo: "You can see details about delivery price and available quantity in cart."
    },
    addedToCart: {
        title: "Product added to cart",
        quantity: "Quantity"
    },
    swal: {
        moveToWishlist: "You will move this product into Wishlist.",
        removeFromCart: "You are going to remove this product from your cart."
    }
}
